// extracted by mini-css-extract-plugin
export var editInput = "_hz-0";
export var editInputCompact = "_hz-2";
export var editInputLarge = "_hz-1";
export var editInputSmall = "_hz-3";